<template>
  <v-dialog
    v-model="changePinDialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card tile>
      <v-toolbar dark color="info">
        <v-btn icon dark @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Change Pin Number</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items v-if="step !== 4">
          <v-btn dark text :disabled="step === 1" @click="step--"> Back </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card tile flat v-if="changeEmployee">
        <div class="text-center pt-3" v-if="step !== 4">
          <strong>{{ changeEmployee.name }}</strong>
        </div>

        <v-window v-model="step" class="touch-view-container">
          <v-window-item :value="1" style="height: 100%">
            <v-layout
              v-if="changeEmployee"
              column
              justify-center
              align-center
              fill-height
              hide-details
            >
              <v-flex shrink class="pb-3">
                <div class="text-center mb-3">Enter Your Curren Pin Number</div>
                <v-row class="mb-2">
                  <v-col v-for="circle in pinCodeCircles" :key="circle">
                    <v-icon>{{ pinCodeStyle(circle) }}</v-icon>
                  </v-col>
                </v-row>
              </v-flex>

              <v-col>
                <v-row justify="center" fill-height style="height: 100%">
                  <v-col
                    v-for="num in numbers"
                    :key="num"
                    class="col-4 text-center"
                  >
                    <v-card
                      class="rounded-lg"
                      height="100%"
                      ripple 
                      elevation="10"
                      width="100%"
                      color="blue darken-1"
                      dark
                      @pointerdown.stop.prevent="
                        pointerMode && selectedNum(num, 1)
                      "
                      @click.stop.prevent="!pointerMode && selectedNum(num, 1)"
                    >
                      <v-layout
                        v-if="buttonLoading"
                        row
                        fill-height
                        align-center
                        justify-center
                      >
                        <v-flex
                          class="display-4"
                          v-if="$vuetify.breakpoint.smAndDown"
                        >
                          <v-progress-circular
                            :size="70"
                            :width="7"
                            color="white"
                            indeterminate
                          ></v-progress-circular>
                        </v-flex>
                      </v-layout>

                      <v-layout
                        v-else
                        row
                        fill-height
                        align-center
                        justify-center
                      >
                        <v-flex
                          class="display-4"
                          v-if="$vuetify.breakpoint.smAndDown"
                        >
                          {{ num }}
                        </v-flex>
                        <v-flex class="headline" v-else>
                          {{ num }}
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-col>

                  <v-col class="text-center">
                    <v-card
                      class="rounded-lg"
                      height="100%"
                      color="blue darken-1"
                      dark
                      ripple 
                      elevation="10"
                      width="100%"
                      @pointerdown.stop.prevent="
                        pointerMode && selectedNum(0, 1)
                      "
                      @click.stop.prevent="!pointerMode && selectedNum(0, 1)"
                    >

                    <v-layout
                        v-if="buttonLoading"
                        row
                        fill-height
                        align-center
                        justify-center
                      >
                        <v-flex
                          class="display-4"
                          v-if="$vuetify.breakpoint.smAndDown"
                        >
                          <v-progress-circular
                            :size="70"
                            :width="7"
                            color="white"
                            indeterminate
                          ></v-progress-circular>
                        </v-flex>
                      </v-layout>
                      <v-layout v-else row fill-height align-center justify-center>
                        <v-flex
                          class="display-4"
                          v-if="$vuetify.breakpoint.smAndDown"
                        >
                          0
                        </v-flex>
                        <v-flex v-else class="headline"> 0 </v-flex>
                      </v-layout>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-layout>
          </v-window-item>

          <v-window-item :value="2" style="height: 100%">
            <v-layout
              v-if="employee"
              column
              justify-center
              align-center
              fill-height
              hide-details
            >
              <v-flex shrink class="pb-3">
                <div class="text-center mb-3">Enter New Pin Number</div>
                <v-row class="mb-2">
                  <v-col v-for="circle in pinCodeCircles" :key="circle">
                    <v-icon>{{ newPinCodeStyle(circle) }}</v-icon>
                  </v-col>
                </v-row>
              </v-flex>

              <v-col>
                <v-row justify="center" fill-height style="height: 100%">
                  <v-col
                    v-for="num in numbers"
                    :key="num"
                    class="col-4 text-center"
                  >
                    <v-card
                      class="rounded-lg"
                      height="100%"
                      ripple
                      elevation="10"
                      width="100%"
                      color="teal darken-3"
                      dark
                      @pointerdown.stop.prevent="
                        pointerMode && selectedNum(num, 2)
                      "
                      @click.stop.prevent="!pointerMode && selectedNum(num, 2)"
                    >
                      <v-layout row fill-height align-center justify-center>
                        <v-flex
                          class="display-4"
                          v-if="$vuetify.breakpoint.smAndDown"
                        >
                          {{ num }}
                        </v-flex>
                        <v-flex class="headline" v-else>
                          {{ num }}
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-col>

                  <v-col class="text-center">
                    <v-card
                      class="rounded-lg"
                      height="100%"
                      color="teal darken-3"
                      dark
                      ripple
                      elevation="10"
                      width="100%"
                      @pointerdown.stop.prevent="
                        pointerMode && selectedNum(0, 2)
                      "
                      @click.stop.prevent="!pointerMode && selectedNum(0, 2)"
                    >
                      <v-layout row fill-height align-center justify-center>
                        <v-flex
                          class="display-4"
                          v-if="$vuetify.breakpoint.smAndDown"
                        >
                          0
                        </v-flex>
                        <v-flex v-else class="headline"> 0 </v-flex>
                      </v-layout>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-layout>
          </v-window-item>

          <v-window-item :value="3" style="height: 100%">
            <v-layout
              v-if="employee"
              column
              justify-center
              align-center
              fill-height
              hide-details
            >
              <v-flex shrink class="pb-3">
                <div class="text-center mb-3">Reenter Pin Number</div>
                <v-row class="mb-2">
                  <v-col v-for="circle in pinCodeCircles" :key="circle">
                    <v-icon>{{ confirmPinCodeStyle(circle) }}</v-icon>
                  </v-col>
                </v-row>
              </v-flex>

              <v-col>
                <v-row justify="center" fill-height style="height: 100%">
                  <v-col
                    v-for="num in numbers"
                    :key="num"
                    class="col-4 text-center"
                  >
                    <v-card
                      class="rounded-lg"
                      height="100%"
                      ripple
                      elevation="10"
                      width="100%"
                      color="teal darken-3"
                      dark
                      @pointerdown.stop.prevent="
                        pointerMode && selectedNum(num, 3)
                      "
                      @click.stop.prevent="!pointerMode && selectedNum(num, 3)"
                    >
                      <v-layout row fill-height align-center justify-center>
                        <v-flex
                          class="display-4"
                          v-if="$vuetify.breakpoint.smAndDown"
                        >
                          {{ num }}
                        </v-flex>
                        <v-flex class="headline" v-else>
                          {{ num }}
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-col>

                  <v-col class="text-center">
                    <v-card
                      class="rounded-lg"
                      height="100%"
                      color="teal darken-3"
                      dark
                      ripple
                      elevation="10"
                      width="100%"
                      @pointerdown.stop.prevent="
                        pointerMode && selectedNum(0, 3)
                      "
                      @click.stop.prevent="!pointerMode && selectedNum(0, 3)"
                    >
                      <v-layout row fill-height align-center justify-center>
                        <v-flex
                          class="display-4"
                          v-if="$vuetify.breakpoint.smAndDown"
                        >
                          0
                        </v-flex>
                        <v-flex v-else class="headline"> 0 </v-flex>
                      </v-layout>
                    </v-card>
                  </v-col>
                </v-row>
              </v-col>
            </v-layout>
          </v-window-item>

          <v-window-item :value="4" style="height: 100%">
            <v-card-text>
              <div class="text-h2 text-center mt-5 mb-10">Please wait</div>
              <div class="text-center my-5">
                <v-progress-circular
                  :size="70"
                  :width="7"
                  color="purple"
                  indeterminate
                ></v-progress-circular>
              </div>
              <div class="text-h4 font-weight-regular">Saving</div>
              <div class="text-h4 font-weight-regular">New Pin Number</div>
            </v-card-text>
          </v-window-item>
        </v-window>
      </v-card>
    </v-card>
  </v-dialog>
</template>


<script>
import employeeService from "@/modules/Employee/service.js";
import timeClockService from "@/modules/TimeClock/service.js";
import authService from "@/modules/Authentication/service.js";

export default {
  props: ["dialog", "changeEmployee"],
  data() {
    return {
      buttonLoading: false,
      employee: null,
      pointerMode: "PointerEvent" in window,
      pin: "",
      newPin: "",
      confirmPin: "",
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      pinCodeCircles: [1, 2, 3, 4],
      changePinDialog: false,
      step: 1,
      locationCode: null,
      deviceCode: null,
      deviceName: null,
    };
  },
  computed: {
    currentTitle() {
      switch (this.step) {
        case 1:
          return "Sign-up";
        case 2:
          return "Create a password";
        default:
          return "Account created";
      }
    },
  },
  watch: {
    async dialog(val) {
      this.locationCode = localStorage.getItem(
        `${process.env.VUE_APP_STORAGE_PREFIX}code`
      );
      const { deviceName, deviceCode } = authService.getStoredDevice();
      this.deviceName = deviceName;
      this.deviceCode = deviceCode;
      // console.log("val", val);
      // this.employee = (
      //   await timeClockService.getEmployeeTimeClock(this.changeEmployee.id)
      // ).data;
      // console.log("test", this.employee);
      this.changePinDialog = val;
    },
    step(val) {
      if (val === 1) this.empty();
      if (val === 4) this.updatePinNumber();
    },
  },
  methods: {
    updatePinNumber() {
      this.$Progress.start();
      employeeService
        .update(this.employee.id, { pinCode: this.newPin })
        .then(() => {
          this.$toast.success("Employee Updated", { timeout: 2000 });
          this.$Progress.finish();
          this.close();
        })
        .catch((err) => {
          console.log(err);
          this.$toast.error(err.data ? err.data.message : "Error", {
            timeout: 2000,
          });
          this.$Progress.fail();
        });
    },
    pinCodeStyle(num) {
      if (this.pin.length >= num) return "mdi-circle";
      else return "mdi-checkbox-blank-circle-outline";
    },
    confirmPinCodeStyle(num) {
      if (this.confirmPin.length >= num) return "mdi-circle";
      else return "mdi-checkbox-blank-circle-outline";
    },
    newPinCodeStyle(num) {
      if (this.newPin.length >= num) return "mdi-circle";
      else return "mdi-checkbox-blank-circle-outline";
    },
    generateTimeClockToken() {
      let rand = function () {
        return Math.random().toString(36).substr(2);
      };

      return rand() + rand();
    },
    async getToken() {
      this.$Progress.start();
      const loginInfo = {
        id: this.changeEmployee.id,
        pin: this.pin,
        locationCode: this.locationCode,
        deviceCode: this.deviceCode,
        deviceName: this.deviceName,
      };
      try {
        await authService.authenticate(loginInfo);
        return true;
      } catch (err) {
        this.$toast.error("Wrong Pin Number Try Again", {
          timeout: 2000,
        });
        this.empty();
        return false;
      }
    },
    async selectedNum(num, step) {
      num = num.toString();
      if (step === 1) {
        this.pin = this.pin.concat(num).trim();

        if (this.pin.length === 4) {
          this.buttonLoading = true
          if (await this.getToken()) {
            this.employee = (
              await timeClockService.getEmployeeTimeClock(
                this.changeEmployee.id
              )
            ).data;
            if (this.employee.pinCode === this.pin) {
              this.step = 2;
            } else {
              this.$toast.error("Wrong Pin Number Try Again", {
                timeout: 2000,
              });
              this.empty();
            }
          } else {
            this.empty();
          }
        }
      }
      if (step === 2) {
        this.newPin = this.newPin.concat(num).trim();
        if (this.newPin.length === 4) {
          this.step = 3;
        }
      }
      if (step === 3) {
        this.confirmPin = this.confirmPin.concat(num).trim();
        if (this.confirmPin.length === 4) {
          if (this.confirmPin === this.newPin) {
            this.step = 4;
          } else {
            this.$toast.error("Pin Number did not match!", { timeout: 2000 });
            this.confirmPin = "";
            this.newPin = "";
            this.step = 2;
            // this.empty()
          }
        }
      }
    },
    close() {
      this.$emit("close");
      this.empty();
    },
    empty() {
      this.step = 1;
      this.pin = "";
      this.newPin = "";
      this.confirmPin = "";
      this.buttonLoading = false
    },
  },
};
</script>

<style scoped >
.touch-view-container {
  height: calc(100vh - 95px);
  overflow: auto;
}
</style>